import { Controller } from "@hotwired/stimulus"
import {get, post} from "@rails/request.js"

// Connects to data-controller="airports-replace"
export default class extends Controller {
  static values = {
    url: String
  }

  change(event) {
    const url = this.urlValue

    get(`${url}?flight=${event.target.value}`, {
      responseKind: "turbo-stream"
    })
  }
}
